import React from "react";
import { UserPointContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment-timezone";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { Displays, Inputs, Tables } from "components";
import { toast } from "react-toastify";
import {
  parseFilterQuery,
  syncFilterUrlQuery,
} from "utils/functions/filterQuery";

const FILTER_FIELDS = ["user_id", "customer_cu_id", "start_date", "end_date"];

const renderPoint = (value) => RenderCommaMoney(Number(value || 0), true);

// ยอดใน wallet ปัจจุบัน ถ้าลูกค้าไม่มี wallet (has_wallet=false) ให้แสดง "ผิดพลาด" เหมือนเดิม
const renderPointInSystem = (e) =>
  !e.has_wallet ? "ผิดพลาด" : renderPoint(e.point_in_system);

// API /wallet-history/summary group ยอดต่อลูกค้าให้แล้ว (received/redeem/expired/system error)
// จึงใช้ server pagination ได้ ไม่ต้องดึงทุกแถวมารวมในเบราว์เซอร์เหมือนเดิม
class UserPointContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    // เปลี่ยน key เพื่อบังคับสร้าง InputFilter ใหม่ตอนกดล้างค่า
    filterKey: 0,
    ...parseFilterQuery(this.props.router.location.search, FILTER_FIELDS),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_WALLET_HISTORY_SUMMARY(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ data: [], isLoading: false, pagination: null });
      toast.error("โหลดข้อมูลไม่สำเร็จ");
    }
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseFilterQuery(e, FILTER_FIELDS);
    this.setState({ ...parsedQuery });
    this.handleJoinQuery(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseFilterQuery("", FILTER_FIELDS),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery("", 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    syncFilterUrlQuery(this.props.router, query, page);
    this.fetchData(joinQuery);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_WALLET_HISTORY_SUMMARY(joinQuery);
    if (!res || res.status !== 200) {
      this.setState({ isBgLoading: false });
      toast.error("Export ไม่สำเร็จ");
      return;
    }
    var wb = XLSX.utils.book_new();
    var ws_name = "SheetJS";
    var ws_data = res.data.docs.reduce((result, e, i) => {
      result.push([
        i + 1,
        `${e.customer_user_id || ""}`,
        `${e.customer_cu_id || ""}`,
        e.last_created_at
          ? moment(e.last_created_at)
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm:ss")
          : "",
        renderPoint(e.received_point),
        renderPoint(e.redeem_point),
        renderPoint(e.expired_point),
        renderPoint(e.remaining_point),
        renderPointInSystem(e),
        renderPoint(-Number(e.system_error_point || 0)),
      ]);
      return result;
    }, []);

    ws_data.splice(0, 0, [
      "No",
      "Login ID",
      "CU code",
      "Last activity",
      "Total received point",
      "Redeem point",
      "Expired point",
      "Remaining point",
      "Point in system",
      "System error",
    ]);
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    var wscols = [
      { wch: 5 },
      { wch: 35 },
      { wch: 15 },
      { wch: 25 },
      { wch: 18 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
    ];
    ws["!cols"] = wscols;
    /* Add the worksheet to the workbook */
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(
      wb,
      `User point report ${moment()
        .tz("Asia/Bangkok")
        .format("DD/MM/YYYY")}.xlsx`
    );
    this.setState({
      isBgLoading: false,
    });
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      pagination,
      data,
      filterValues,
      filterKey,
    } = this.state;
    return (
      <UserPointContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="418px" />
        ) : (
          <Tables.Standard
            columns={columns}
            data={data}
            showPagination
            pagination={pagination}
            handlePageClick={this.handlePageClick}
          />
        )}
      </UserPointContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: "user_id",
    length: "250px",
    filter: {
      fieldQuery: "user_id",
      type: "text",
      defaultValue: filterValues.user_id,
      label: "Login ID : ",
      placeholder: "Login ID",
    },
  },
  {
    accessor: "customer_cu_id",
    length: "200px",
    filter: {
      fieldQuery: "customer_cu_id",
      type: "text",
      defaultValue: filterValues.customer_cu_id,
      label: "CU code : ",
      placeholder: "CU code",
    },
  },
  {
    accessor: "date",
    filter: {
      fieldQuery: "date",
      type: "dateRank",
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: "Date Range : ",
    },
  },
];

const columns = [
  {
    Header: <div style={{ textAlign: "left" }}>Login ID</div>,
    accessor: "customer_user_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>CU code</div>,
    accessor: "customer_cu_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Last activity</div>,
    accessor: "last_created_at",
    Cell: (props) =>
      props.value
        ? moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm:ss")
        : "-",
  },
  {
    Header: <div style={{ textAlign: "center" }}>Total received point</div>,
    accessor: "received_point",
    Cell: (props) => (
      <div style={{ textAlign: "center" }}>{renderPoint(props.value)}</div>
    ),
  },
  {
    Header: "Redeem point",
    accessor: "redeem_point",
    Cell: (props) => (
      <div style={{ textAlign: "center" }}>{renderPoint(props.value)}</div>
    ),
  },
  {
    Header: "Expired point",
    accessor: "expired_point",
    Cell: (props) => (
      <div style={{ textAlign: "center" }}>{renderPoint(props.value)}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: "right" }}>Remaining point</div>,
    accessor: "remaining_point",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>{renderPoint(props.value)}</div>
    ),
  },
  {
    Header: "Point in system",
    accessor: "point_in_system",
    Cell: (props) => (
      <div style={{ textAlign: "center" }}>
        {renderPointInSystem(props.row.original)}
      </div>
    ),
  },
  {
    Header: "System error",
    accessor: "system_error_point",
    Cell: (props) => (
      <div style={{ textAlign: "center" }}>
        {renderPoint(-Number(props.value || 0))}
      </div>
    ),
  },
];

export default withRouter(UserPointContainer);
